module.exports = __webpack_public_path__ + "static/media/Cavalier075_1c.d4ae696e.svg";